import taskController from '../internals/taskController';

export type MutationType = {
  label: string;
  (): Promise<any>;
};

const describeMutation = <RunnerArgumentsType>(
  label: string,
  runner: (args: RunnerArgumentsType) => any,
) => {
  // ensure mutations are async
  const mutation = (args: RunnerArgumentsType) => Promise.resolve(runner(args));

  mutation.label = label;

  // thread resolve/reject control into taskController so that users can expect normal promise behavior
  const runMutation = (callWith: RunnerArgumentsType) =>
    new Promise((resolve, reject) => {
      taskController.acceptMutation({
        // @ts-expect-error dunno
        mutation,
        callWith: [callWith],
        resolve,
        reject,
      });
    });

  return runMutation;
};

export default describeMutation;
